import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { fetchContentCategories } from '../redux/contentCategories/actions';
import { selectContentCategoriesCatalog, selectContentCategoriesFetching } from '../redux/contentCategories/selectors';
import { RootState } from '../redux/root-reducer';
import { getCachedContentCategories, type IContentCategoryCatalog } from '../utils/contentCategoriesApi';
import { useDispatchPromise } from '../utils/AppUtils';

/** Loads content categories (API source of truth, static fallback). */
export function useContentCategories() {
    const token = useSelector((s: RootState) => s.authentication.token);
    const dispatchPromise = useDispatchPromise();
    const catalogFromRedux = useSelector(selectContentCategoriesCatalog);
    const fetchingFromRedux = useSelector(selectContentCategoriesFetching);

    useEffect(() => {
        void dispatchPromise(fetchContentCategories(undefined));
    }, [token, dispatchPromise]);

    const catalog: IContentCategoryCatalog = useMemo(
        () => catalogFromRedux ?? getCachedContentCategories(),
        [catalogFromRedux],
    );

    const loading = fetchingFromRedux || (!catalogFromRedux && catalog.source === 'fallback');

    return {
        catalog,
        loading,
        mains: catalog.mains,
        mainsAlphabetical: catalog.mainsAlphabetical,
        popular: catalog.popular,
    };
}
